import _ from "lodash";
import { Accounting } from "../../../gateway/Accounting/Accounting";
import { Company } from "../../../gateway/Company/Company";
import { Events } from "../Events/Events";
import {
    analysisPlusDialogTemplate,
    analysisPlusRequestPlanDialogTemplate
} from "../../../views/accounting/company/dashboards/dashboards.dialog-templates";
import toastCustomTemplate from "../../../shared/components/nu-toast-custom/toast-custom.component.html";

export class RequestAnalysisPlus {
    Accounting = new Accounting();
    Company = new Company();
    Events = new Events();

    constructor({ DSNDialogService, toast, mdDialog }) {
        this.DSNDialogService = DSNDialogService;
        this.toast = toast;
        this.mdDialog = mdDialog;
    }

    async getAnalysisPlusLicences(accountingId) {
        const accounting = await this.Accounting.getById(accountingId);
        const accountingAnalysisPlus = accounting?.plan?.analysisPlus || {
            companies: [],
            limit: 0
        };
        const limitCompanies = accountingAnalysisPlus.limit;
        const countCompanies = accountingAnalysisPlus.companies?.length || 0;
        return {
            limitCompanies,
            countCompanies,
            companies: accountingAnalysisPlus.companies
        };
    }

    onGetLabelEmpty(accounting) {
        if (accounting.hasAccountingAnalysisPlus()) {
            return {
                label: "Solicitar mudança de Plano",
                icon: "fas fa-rocket"
            };
        } else {
        }
    }

    onOpenDialogRequestAnalysisPlus(
        accountingEntity,
        companyData,
        callback = () => {}
    ) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "AnalysisPlusDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                callback,
                width: "348px",
                accountingEntity: accountingEntity,
                companyData,
                accountingId: accountingEntity.props._id,
                templateHtml: analysisPlusDialogTemplate
            },
            after: {
                hide: (params) => {}
            }
        });
    }

    onOpenDialogRequestAnalysisPlusPlan(accountingEntity, callback) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "AnalysisPlusRequestPlanDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                rocketIcon: true,
                title: "Análise Plus",
                width: "380px",
                accountingEntity: accountingEntity,
                templateHtml: analysisPlusRequestPlanDialogTemplate
            },

            after: {
                hide: () => {
                    if (callback) callback();
                }
            }
        });
    }

    async onActivateAnalysisPlus(
        accountingEntity,
        company,
        callback = () => {}
    ) {
        this.loading = true;

        this.mdDialog.hide();

        await this.updateAnalysisPlus({
            company,
            status: true,
            accountingId: accountingEntity.props._id
        });
        this.Events.send("grow.dialog.analiseplus.ativar.licencas");
        accountingEntity.activateAnalysisPlus(company, true);

        callback({ response: "success" });

        location.reload();

        this.loading = false;
        // const {
        //     limitCompanies,
        //     countCompanies
        // } = await this.getAnalysisPlusLicences(accountingEntity.props._id);

        // const description = `Ao ativar a Análise Plus para esta empresa, você desbloqueará recursos, incluindo <strong>Orçamentos</strong>, <strong>Projeções</strong>, <strong>Objetivos</strong> e <strong>Benchmarking</strong>.<div class="margin-top-analysis-plus"></div>Atualmente, você possui <strong>${countCompanies}</strong> das <strong>${limitCompanies}</strong> licenças da Análise Plus disponíveis em seu plano. Lembre-se de que essa funcionalidade não pode ser desativada após a ativação.`;
        // this.DSNDialogService.confirmation({
        //     locals: {
        //         title: "Solicitar Análise Plus",
        //         description,
        //         actions: {
        //             confirm: {
        //                 label: "Ativar",
        //                 action: async () => {
        //                     this.loading = true;

        //                     this.mdDialog.hide();

        //                     await this.updateAnalysisPlus({
        //                         company,
        //                         status: true,
        //                         accountingId: accountingEntity.props._id
        //                     });
        //                     this.Events.send(
        //                         "grow.dialog.analiseplus.ativar.licencas"
        //                     );
        //                     accountingEntity.activateAnalysisPlus(
        //                         company,
        //                         true
        //                     );

        //                     callback({ response: "success" });

        //                     location.reload();

        //                     this.loading = false;
        //                 }
        //             },
        //             cancel: {
        //                 label: "Cancelar",
        //                 action: () => {
        //                     this.mdDialog.cancel();
        //                     callback({ response: "cancel" });
        //                 }
        //             }
        //         }
        //     },
        //     after: {
        //         cancel: () => {}
        //     }
        // });
    }

    async updateAnalysisPlus({ company, status, accountingId }) {
        this.loading = true;

        const response = await this.Accounting.updateAnalysisPlus({
            accountingId,
            company: { _id: company._id, name: company.name, status }
        });

        if (_.get(response, "message")) {
            this.showToastError("Não foi possível ativar esta empresa.");
            this.loading = false;
            return;
        }
        const analysisPlus = {
            status,
            date: new Date()
        };
        if (!status) delete analysisPlus.date;
        this.Company.modify(
            { _id: company._id },
            {
                $set: { "events.analysisPlus": analysisPlus }
            }
        );
        _.set(company, "events.analysisPlus", analysisPlus);
        // this.locals.updateCompanyAnalysisPlus({
        //     status,
        //     date: new Date()
        // });

        this.showToastError("Ativação realizada com sucesso.");

        this.loading = false;
    }

    showToastError(toastMessage) {
        this.toast.show("", "bottom right", {
            hideDelay: 10e3,
            controllerAs: "ctrl",
            locals: {
                toastMessage,
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }
}
